module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-year-2026-346bf27e11619a560f04348600f89d80.svg";